import { msUntilNextRound } from '@geosport/shared';
import { useEffect, useState } from 'react';

function format(ms: number): string {
  const s = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return `${h}:${m.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
}

/** "h:mm:ss" until the next round goes live at 00:00 London time. */
export function useCountdown(): string {
  const [text, setText] = useState(() => format(msUntilNextRound()));
  useEffect(() => {
    const id = window.setInterval(() => setText(format(msUntilNextRound())), 1000);
    return () => window.clearInterval(id);
  }, []);
  return text;
}
